import {
  u2000GetActiveDisplayTimezone,
  u2000ReadWallClock,
} from '../../u2000Core/tools/U2000DateTimeHelpers';

/** Affiche un instant ISO en `yyyy-MM-dd HH:mm:ss` dans le fuseau org actif. */
export function u3204FormatIndexedAtOrg(iso: string | null | undefined): string {
  if (iso == null || String(iso).trim() === '') return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const p = u2000ReadWallClock(d.getTime(), u2000GetActiveDisplayTimezone());
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${p.y}-${pad(p.mo)}-${pad(p.d)} ${pad(p.h)}:${pad(p.mi)}:${pad(p.s)}`;
}

/** Tronque un hash pour affichage table (préfixe 12 + …). */
export function u3204TruncateHash(hash: string | null | undefined, keep = 12): string {
  if (!hash) return '—';
  if (hash.length <= keep) return hash;
  return `${hash.slice(0, keep)}…`;
}
